import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getDoctorList = (formData) => {
    return axiosInstance.post(`api/doctors/list`, formData);
}

export const statusDoctor = (id, payload = {}) => {
    return axiosInstance.post(`api/doctors/change-status/${id}`, payload);
}

export const deleteDoctor = (id, payload = {}) => {
    return axiosInstance.post(`api/doctors/delete/${id}`, payload);
}

export const addDoctor = (formData) => {
    return axiosInstance.post(`api/doctors/add`,formData);
}

export const updateDoctor = (id,formData) => {
    return axiosInstance.post(`api/doctors/update/${id}`,formData);
}

export const viewDoctor = (id, payload = {}) => {
    return axiosInstance.post(`api/doctors/detail/${id}`, payload);
}

export const masterTest = () => {
    return axiosInstance.post(`api/test/master`,{});
}

export const peymentDoctor = (formData) => {
    return axiosInstance.post(`api/doctors/pay-commision`,formData);
}

export const testListBytDoctor = (id,formData) => {
    return axiosInstance.post(`api/doctors/list-of-commsion/${id}`,formData);
}